import React from "react";
import { useTranslation } from "react-i18next";
import { AnimatedModal, modalPanelClass } from "./AnimatedModal";
import { HiOutlineXMark, HiOutlineTrash } from "react-icons/hi2";

interface ConfirmDeleteModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  itemName: string;
}

const ConfirmDeleteEvent: React.FC<ConfirmDeleteModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  itemName,
}) => {
  const { t } = useTranslation();

  return (
    <AnimatedModal isOpen={isOpen} onClose={onClose} contentClassName="sm:max-w-md">
      <div className={modalPanelClass}>
        <div className="sm:hidden flex justify-center pt-2 pb-1 shrink-0">
          <div className="w-10 h-1 rounded-full bg-gray-300 dark:bg-gray-600" />
        </div>
        <div className="flex items-center justify-between px-4 sm:px-5 py-3 sm:py-4 border-b border-gray-100 dark:border-gray-700 shrink-0">
          <div className="flex items-center gap-2.5">
            <div className="flex items-center justify-center w-9 h-9 rounded-xl bg-red-500/10 dark:bg-red-500/20 text-red-500">
              <HiOutlineTrash className="w-5 h-5" strokeWidth={2} />
            </div>
            <h2 className="text-lg font-semibold text-gray-800 dark:text-gray-100">
              {t("confirmDeleteTitle")}
            </h2>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="p-2.5 rounded-xl text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
            aria-label={t("close")}
          >
            <HiOutlineXMark className="w-5 h-5" />
          </button>
        </div>
        <div className="p-4 sm:p-5 space-y-5">
          <p className="text-gray-600 dark:text-gray-400">
            {t("confirmDeleteMessageEvent", { itemName })}
          </p>
          <div className="flex flex-col-reverse sm:flex-row gap-2 sm:gap-3">
            <button
              type="button"
              onClick={onClose}
              className="w-full sm:flex-1 py-3 sm:py-2.5 rounded-xl font-medium border border-gray-200 dark:border-gray-600 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors"
            >
              {t("cancelButton") || t("cancel")}
            </button>
            <button
              type="button"
              onClick={onConfirm}
              className="w-full sm:flex-1 py-3 sm:py-2.5 rounded-xl font-medium bg-red-500 text-white hover:bg-red-600 transition-colors"
            >
              {t("deleteButton") || t("delete")}
            </button>
          </div>
        </div>
      </div>
    </AnimatedModal>
  );
};

export default ConfirmDeleteEvent;
